
//侧边栏  路由数据基础数据
const storeData = {
	navList :  [
		{id:1,p_id:0,title:'首页',icon:'icon iconfont iconshujufenxi',isHover:true,path:'/admin/index2',isShow:true,closeIcon:false,navGrade:1,isCourrentWeb:true,children:[]},
		// {id:1,p_id:0,title:'数据分析',icon:'icon iconfont iconshujufenxi',isHover:true,path:'/admin/index',isShow:true,closeIcon:false,navGrade:1,isCourrentWeb:true,children:[]},
		{id:2, p_id: 0, title: '账号管理', icon: 'icon iconfont iconzhanghaoguanli', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
			children: [
				{id:21,p_id:2,title:'后台账号',icon:'icon iconfont iconzhanghao',isHover:false,path:'/admin/account',isShow:false,closeIcon:false,navGrade:2,isCourrentWeb:false},
				{id:22,p_id:2,title:'权限管理',icon:'icon iconfont iconquanxianguanli',isHover:false,path:'/admin/jurisdiction',isShow:false,closeIcon:false,navGrade:2,isCourrentWeb:false},
				{id:23,p_id:2,title:'角色管理',icon:'icon iconfont iconjiaoseguanli',isHover:false,path:'/admin/role',isShow:false,closeIcon:false,navGrade:2,isCourrentWeb:false}
			]
		},
		// {id:3, p_id: 0, title: '用户管理', icon: 'icon iconfont icon-shouye', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
		//     children: [
		//         { id: 31, p_id: 3, title: '用户账号', icon: 'icon iconfont icon-shouye', isHover: false, path: '/admin/user', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
		//         {id:32,p_id:3,title:'资金账户',icon:'icon iconfont icon-shouye',isHover:false,path:'/admin/capital',isShow:false,closeIcon:false,navGrade:2,isCourrentWeb:false},
		//         {id:33,p_id:3,title:'金币账户',icon:'icon iconfont icon-shouye',isHover:false,path:'/admin/goldCoing',isShow:false,closeIcon:false,navGrade:2,isCourrentWeb:false},
		//     ]
		// },
		{id:4, p_id: 0, title: '网站管理', icon: 'icon iconfont iconwangzhanguanli', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
			children: [
				// { id: 41, p_id: 4, title: '异常管理', icon: 'icon iconfont iconyichangguanli', isHover: false, path: '/admin/abnormal', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				// { id: 42, p_id: 4, title: '页面设置', icon: 'icon iconfont iconyemianshezhi', isHover: false, path: '/admin/web', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				// { id: 43, p_id: 4, title: '热搜词管理', icon: 'icon iconfont  iconresou', isHover: false, path: '/admin/hotSearch', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				// { id: 44, p_id: 4, title: '网站地图', icon: 'icon iconfont iconditu', isHover: false, path: '/admin/sitemap', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				{ id: 45, p_id: 4, title: '网站配置', icon: 'icon iconfont iconpeizhi', isHover: false, path: '/admin/ConfigurationList', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				{ id: 46, p_id: 4, title: '缓存管理', icon: 'icon iconfont iconqinglihuancun', isHover: false, path: '/admin/cache', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				
				
			]
		},
		{id:5, p_id: 0, title: '图片管理', icon: 'icon iconfont iconxiaoshuo', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
			children: [
				{ id: 51, p_id: 5, title: '图片分类', icon: 'icon iconfont iconleimupinleifenleileibie2', isHover: false, path: '/admin/imgClass', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
				{ id: 52, p_id: 5, title: '图片列表', icon: 'icon iconfont iconliebiao', isHover: false, path: '/admin/img', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
			]
		},
		// {id:6, p_id: 0, title: '广告管理', icon: 'icon iconfont iconxiaoshuo', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
		// 	children: [
		// 		{ id: 61, p_id: 6, title: '广告分类', icon: 'icon iconfont iconleimupinleifenleileibie2', isHover: false, path: '/admin/adType', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
		// 		{ id: 62, p_id: 6, title: '广告列表', icon: 'icon iconfont iconliebiao', isHover: false, path: '/admin/ad', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
		// 	]
		// },
		// {id:7, p_id: 0, title: '账单管理', icon: 'icon iconfont iconxiaoshuo', isHover: false, path: '', isShow: false, closeIcon: false, navGrade: 1, isCourrentWeb: false,
		// 	children: [
		// 		{ id: 71, p_id: 7, title: '账单列表', icon: 'icon iconfont iconliebiao', isHover: false, path: '/admin/bill', isShow: false, closeIcon: false, navGrade: 2, isCourrentWeb: false },
		// 	]
		// },
	],
	//head 标签  
	tags: [
		{id:1,p_id:0,title:'数据分析',icon:'icon iconfont icon-shezhi',isHover:true,path:'/admin/index',isShow:true,closeIcon:false,navGrade:1,isCourrentWeb:true,children:[]},
	],
	//head 顶部路由
	routePath: [
		{id:1,p_id:0,title:'数据分析',icon:'icon iconfont icon-shezhi',isHover:true,path:'/admin/index',isShow:true,closeIcon:false,navGrade:1,isCourrentWeb:true,children:[]},
	]
}


export default {
	storeData
}